import { experimentalStyled as styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import AppointmentCard from "../../../../components/AppointmentCard";
import { useEffect, useState } from "react";
import { GetAppointments, InsertPPLogs } from "../../../../api";
import { Appointment } from "../../../../store";

// Update log
// FB  6192   02/06/2023  DK  Added page to handle past appointments 

export default function PastAppointments() {
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));
  const [appointments, setAppointments] = useState<Appointment[]>();

  async function GetAppointment() {
    var data = sessionStorage.getItem("user");
    if (data != null) {
      const user = JSON.parse(data);
      if (user.EMRID != null) {
        const data = await GetAppointments(user.EMRID, "past");
        setAppointments(data);
      }
    }
  }
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }
  async function InsertLogs() {
    InsertPPLogs(
      "Viewing Past appointments",
      window.location.href,
      userName,
      ""
    );
  }

  useEffect(() => {
    GetAppointment();
    InsertLogs();
  }, []);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={{ xs: 2, md: 3 }}>
        {appointments != undefined ? (
          appointments.map((appointment, index) => (
            <Grid item xs={12} sm={6} md={6} lg={4} key={index}>
              <AppointmentCard
                date={new Date(appointment.Date).toDateString()}
                time={new Date(appointment.Date).toLocaleTimeString()}
                provider={appointment.Provider}
                location={appointment.Location}
                type={appointment.Type}
                parent="Past Appointments"
              />
            </Grid>
          ))
        ) : (
          <Grid item xs={12} sm={6} md={6} lg={4}>
            <AppointmentCard isempty={true} parent="Past Appointments" />
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
